import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import saveAs from 'file-saver';
import { PaymentScheduleTabName } from '../../../models/_enum-collections';
import { DownloadPaymentScheduleCSV } from '../../../models/download-payment-schedule-csv.model';
import { SettingsService } from '../../common/settings.service';
import { PaymentScheduleService } from '../../services/payment-schedule.service';
import { PaymentBatchTableComponent } from '../../shared/payment-batch-table/payment-batch-table.component';

@Component({
  selector: 'app-payment-schedule-milestone2',
  templateUrl: './payment-schedule-milestone2.component.html',
  styleUrls: ['./payment-schedule-milestone2.component.scss'],
  standalone: true,
  imports: [PaymentBatchTableComponent]
})
export class PaymentScheduleMilestone2Component implements OnInit {
  isSpin = false;
  downloadCSV: DownloadPaymentScheduleCSV[] = [];
  tabName!: PaymentScheduleTabName;

  constructor(
    private pmService: PaymentScheduleService,
    public settings: SettingsService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.tabName = PaymentScheduleTabName.Milestone2;
    this.getDownloadCSVFile();
  }

  getDownloadCSVFile() {
    this.pmService.getDownloadCSVFile().subscribe(downloadReport => {
      this.downloadCSV = downloadReport;
    });
  }

  exportCSV() {
    this.isSpin = true;
    const fileName = this.downloadCSV[0].fileName;
    const headers = new HttpHeaders();
    const downloadUrl =
      this.settings.baseUrl +
      'api/PaymentSchedule/DownloadFile/' +
      'ADD' +
      '/FileName/' +
      fileName;

    this.http
      .get(downloadUrl, {
        headers,
        responseType: 'blob'
      })
      .subscribe(downloadFile => {
        this.isSpin = false;
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(file, fileName);
      });
  }
}
